import PackageConfig from './PackageConfig'
export class VendPackage {
    ID: number;
    Name: string;
    Inactive: boolean;
    PackageConfigs?: PackageConfig[];
}

export default VendPackage;